module.exports = __webpack_public_path__ + "static/media/achievement.a654484c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/achievement.png
// module id = 270
// module chunks = 0